export const BUILDER_API_KEY: string = String(process.env.NEXT_PUBLIC_BUILDER_API_KEY);
export const BUILDER_CORE_API_KEY: string = String(process.env.NEXT_PUBLIC_CORE_BUILDER_API_KEY);
export const GTM_ID: string = String(process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID) ?? '';
export const ALGOLIA_APP_ID: string = String(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID) ?? '';
export const ALGOLIA_API_KEY: string = String(process.env.NEXT_PUBLIC_ALGOLIA_API_KEY) ?? '';
